import React from 'react';
import { Layout, Menu, Button, Typography } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  LogoutOutlined,
  CalendarOutlined,
  BarChartOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import authService from '../../services/auth';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getUser();

  const handleLogout = async () => {
    await authService.logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '可视化看板',
    },
    {
      key: '/monthly',
      icon: <CalendarOutlined />,
      label: '月度报表',
    },
    {
      key: '/yearly',
      icon: <BarChartOutlined />,
      label: '年度报表',
    },
    {
      key: '/bills',
      icon: <FileTextOutlined />,
      label: '账单管理',
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        theme="light" 
        width={200}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100
        }}
      >
        <div style={{ padding: '16px', textAlign: 'center' }}>
          <Title level={4} style={{ margin: 0 }}>账单管理</Title>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <Layout style={{ marginLeft: 200 }}>
        <Header style={{ 
          background: '#fff', 
          padding: '0 24px', 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          right: 0,
          left: 200,
          zIndex: 99,
          boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
        }}>
          <span style={{ marginRight: 16 }}>
            欢迎，{user?.username || '用户'}
          </span>
          <Button 
            icon={<LogoutOutlined />} 
            onClick={handleLogout}
          >
            退出
          </Button>
        </Header>
        <Content style={{ 
          margin: '88px 24px 24px', 
          background: '#fff', 
          padding: 24, 
          minHeight: 'calc(100vh - 112px)',
          overflow: 'auto'
        }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
